import { toast } from 'react-toastify';
import { getErrorMessage } from '@common/utils';
import { AxiosError } from 'axios';

export const showToastErrorMessage = (
  error: AxiosError | unknown,
  options?: { containerId: string },
) => {
  const errorMessage = getErrorMessage(error);
  toast.error(errorMessage, { containerId: options?.containerId });
};
